import { NavLink } from 'react-router-dom';

const PRIMARY_ITEMS = [
  { to: '/dashboard', icon: 'D', label: 'Home' },
  { to: '/projects', icon: 'P', label: 'Projects' },
  { to: '/tasks', icon: 'T', label: 'Tasks' },
  { to: '/payments', icon: '$', label: 'Finance' },
];

export default function MobileBottomNav({ onMoreClick }) {
  return (
    <nav className="mobile-bottom-nav" aria-label="Primary mobile navigation">
      {PRIMARY_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `mobile-nav-item${isActive ? ' active' : ''}`}
        >
          <span className="mobile-nav-icon">{item.icon}</span>
          <span className="mobile-nav-label">{item.label}</span>
        </NavLink>
      ))}
      <button type="button" className="mobile-nav-item mobile-nav-more" onClick={onMoreClick}>
        <span className="mobile-nav-icon">...</span>
        <span className="mobile-nav-label">More</span>
      </button>
    </nav>
  );
}
